import React, { useEffect, useState } from 'react';
import './Assessment.css'; // Import the CSS file for styling
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { fetchAllAreasDataApi, fetchOneApi ,assesstRisk,getRiskAssessmentByQuarter} from '../../../services/riskServices';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const Assessment: React.FC = () => {
    const { t } = useTranslation();
    const [riskLevel, setRiskLevel] = useState<string>('');
    const [affectedAreas, setAffectedAreas] = useState<string[]>([]);
    const [riskColor, setRiskColor] = useState<string>('#ccc'); // Default color
    const [areas, setAreas] = useState<any[]>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [selectedQuarter, setSelectedQuarter] = useState<string>('Q1'); // Default quarter
    const [riskDescription, setRiskDescription] = useState<string>('');
    const [riskCode, setRiskCode] = useState<string>('');
    const { id } = useParams();

    const handleRiskChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setRiskLevel(value);

        // Update the color based on the selected risk level
        switch (value) {
            case 'least':
                setRiskColor('#92d050'); // Green
                break;
            case 'minimal':
                setRiskColor('#00b050'); // Light Blue
                break;
            case 'moderate':
                setRiskColor('#f5b800'); // Yellow
                break;
            case 'significant':
                setRiskColor('#ff0000'); // Orange
                break;
            case 'most':
                setRiskColor('#c00000'); // Red
                break;
            default:
                setRiskColor('#ccc'); // Default to Green
        }
    };

    const handleAreaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setAffectedAreas(prev => 
            prev.includes(value) ? prev.filter(area => area !== value) : [...prev, value]
        );
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setAffectedAreas([]);
        } else {
            setAffectedAreas(areas.map(area => area.id));
        }
        setSelectAll(!selectAll);
    };

    const handleQuarterChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedQuarter(event.target.value);

    try {
        const response = await getRiskAssessmentByQuarter(id, event.target.value);
        if(response.success && response.data){
            
           setRiskLevel(response.data?.level); // Assuming the level is stored in cbeRiskAssessmentId
           switch (response.data?.level) {
            case 'least':
                setRiskColor('#92d050'); // Green
                break;
            case 'minimal':
                setRiskColor('#00b050'); // Light Blue
                break;
            case 'moderate':
                setRiskColor('#f5b800'); // Yellow
                break;
            case 'significant':
                setRiskColor('#ff0000'); // Orange
                break;
            case 'most':
                setRiskColor('#c00000'); // Red
                break;
            default:
                setRiskColor('#ccc'); // Default to Green
        }
           setAffectedAreas(response.data?.cbeRiskImpactedAreas.map((area :any)=> area.impactedAreaId));
        }
        else{
            toast.error('no assessment found for this quarter');
        }
    } catch (error) {
        console.error('Error fetching risk assessment by quarter:', error);
    }
    };

    const submitAssessment = async () => {
      

        try {
            const response = await assesstRisk({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    riskId: id,
                    level: riskLevel,
                    areaIDs: affectedAreas,
                    quarter: selectedQuarter,
                }
            });

           

            if (!response.success) {
                throw new Error(response.message || 'Failed to submit assessment');
            }

            toast.success('Assessment submitted successfully!');
        } catch (error: any) {
            toast.error(error.message || 'Failed to submit assessment');
        }
    };

    const fetchAreas = async () => {
        const response = await fetchAllAreasDataApi();
        if (response.success) { 
            setAreas(response.data);
        }
        else {
            toast.error(response.message);
        }
    };

    const fetchRiskDescription = async (id: string) => {
        try {
            const response = await fetchOneApi(`cbe-risks/${id}`);
            if (response ) {
              setRiskCode(response?.data?.code);
              setRiskDescription(response?.data?.question); // Store risk details in state
             
                const response2 = await getRiskAssessmentByQuarter(id, 'Q1');
                if(response2.success && response2.data){
                    
                   setRiskLevel(response2.data?.level); // Assuming the level is stored in cbeRiskAssessmentId
                   switch (response2.data?.level) {
                    case 'least':
                        setRiskColor('#92d050'); // Green
                        break;
                    case 'minimal':
                        setRiskColor('#00b050'); // Light Blue
                        break;
                    case 'moderate':
                        setRiskColor('#f5b800'); // Yellow
                        break;
                    case 'significant':
                        setRiskColor('#ff0000'); // Orange
                        break;
                    case 'most':
                        setRiskColor('#c00000'); // Red
                        break;
                    default:
                        setRiskColor('#ccc'); // Default to Green
                }
                   setAffectedAreas(response2.data?.cbeRiskImpactedAreas.map((area :any)=> area.impactedAreaId));
                }
                else{
                    toast.error('no assessment found for this quarter');
                }
             
            } else {
              throw new Error("Failed to fetch risk details");
            }
          } catch (error) {
            toast.error("Failed to fetch risk details");
          } finally {
           
          }
    };

    useEffect(() => {
        fetchAreas();
        if(id){
            fetchRiskDescription(id);
        }
    }, [id]);

    return (
        <div className="root">
            <div className="create-risk-form">
                <Breadcrumb>
                    <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
                    <BreadcrumbItem active style={{ paddingRight: "10px" }}>
                        {t("Risk.Risk")}
                    </BreadcrumbItem>
                    <BreadcrumbItem style={{ paddingRight: '10px' }} active>{t("Risk.Risk_Assessment")}</BreadcrumbItem>
                </Breadcrumb>
                <div className="d-flex justify-content-between align-items-center mb-lg">
                    <h5>{t("Risk.Risk_Assessment")}</h5>
                </div>

                <div className="container_info" style={{ padding: "40px 20px", backgroundColor: "var(--widget-bg)" }}>
                     <div className="risk-description">
                         <h6  className="mb-3" style={{fontSize: "20px" ,fontWeight: "bold" ,color: "#2e76e5"}}>{riskDescription}</h6>
                     </div>
                   
                    <div className="quarter-selection mb-3">
                        <h6>{t("Risk.Select_Quarter")}</h6>
                        <select value={selectedQuarter} onChange={handleQuarterChange} style={{ width: "30%" ,height: "30px" ,borderRadius: "5px" ,border: "1px solid #ccc" ,padding: "5px" ,marginLeft: "10px" }}>
                            <option value="Q1">Q1</option>
                            <option value="Q2">Q2</option>
                            <option value="Q3">Q3</option>
                            <option value="Q4">Q4</option>
                        </select>
                    </div>

                    <div className="risk-level">
                        <div className="d-flex align-items-center mb-3">
                            <h6 className="ml-2">{t("Risk.Select_Risk_Level")}</h6>
                            <div className="risk_level" style={{ backgroundColor: riskColor }}></div>
                        </div>
                        <div className="options d-flex flex-row">
                            <label className="me-3"><input type="radio" name="risk" value="least" onChange={handleRiskChange} checked={riskLevel === 'least'} /> Least</label>
                            <label className="me-3"><input type="radio" name="risk" value="minimal" onChange={handleRiskChange} checked={riskLevel === 'minimal'} /> Minimal</label>
                            <label className="me-3"><input type="radio" name="risk" value="moderate" onChange={handleRiskChange} checked={riskLevel === 'moderate'} /> Moderate</label>
                            <label className="me-3"><input type="radio" name="risk" value="significant" onChange={handleRiskChange} checked={riskLevel === 'significant'} /> Significant</label>
                            <label className="me-3"><input type="radio" name="risk" value="most" onChange={handleRiskChange} checked={riskLevel === 'most'} /> Most</label>
                        </div>
                    </div>

                    <div className="affected-areas mt-2">
                        <h6>{t("Risk.Select_Affected_Areas")}</h6>
                        <div className="options d-flex flex-row flex-wrap mt-4" style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "5px"  }}>
                            <label style={{ flex: '1 0 100%', marginBottom: '10px' }}>
                                <input type="checkbox" checked={selectAll} onChange={handleSelectAllChange} /> {t("Risk.Select_All")}
                            </label>
                            {areas.map((area, index) => (
                                <React.Fragment key={index}>
                                    {index % 4 === 0 && index !== 0 && <div className="w-100"></div>}
                                    <label style={{ flex: '1 0 20%', marginBottom: '10px' }}>
                                        <input type="checkbox" value={area.id} checked={affectedAreas.includes(area.id)} onChange={handleAreaChange} /> {area.name}
                                    </label>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <button className="submit-button_full" type="button" onClick={submitAssessment}>{t("Risk.Submit")}</button>
                </div>
            </div>
        </div>
    );
};

export default Assessment; 